(function () {
	'use strict';

	/* M1o2 global chrome interactions - org conventions (upstream figma-to-static-html-v2):
	   ARIA state on trigger + panel, Escape closes + focus return, outside click closes,
	   body scroll lock while an overlay is open. No globals. */

	/* ---- Announcement bar dismiss (sessionStorage persistence) ---- */
	var DISMISS_KEY = 'm1o2-announcement-dismissed';
	var coupon = document.querySelector('.m1o2-nav__coupon');
	var couponClose = document.querySelector('.m1o2-nav__coupon-close');

	function storageGet(key) {
		try { return window.sessionStorage.getItem(key); } catch (error) { return null; }
	}
	function storageSet(key, value) {
		try { window.sessionStorage.setItem(key, value); } catch (error) { /* storage unavailable */ }
	}

	/* The <html> class is already set synchronously in <head> (theme.liquid) before this
	   file's `defer`red script even runs, so no flash-then-hide on reload; this element
	   class is kept too as a same-load fallback for browsers with sessionStorage disabled. */
	if (coupon && storageGet(DISMISS_KEY) === '1') coupon.classList.add('is-dismissed');
	if (coupon && couponClose) {
		couponClose.addEventListener('click', function () {
			coupon.classList.add('is-dismissed');
			document.documentElement.classList.add('m1o2-announcement-dismissed');
			storageSet(DISMISS_KEY, '1');
		});
	}

	/* ---- Desktop megamenus (Shop / About) ---- */
	var megamenuTriggers = Array.prototype.slice.call(
		document.querySelectorAll('.m1o2-nav__item--trigger[aria-controls]')
	);

	function megamenuPanel(trigger) {
		return document.getElementById(trigger.getAttribute('aria-controls'));
	}
	function setMegamenu(trigger, open) {
		var panel = megamenuPanel(trigger);
		if (!panel) return;
		trigger.setAttribute('aria-expanded', String(open));
		panel.setAttribute('aria-hidden', String(!open));
		panel.classList.toggle('is-open', open);
	}
	function closeAllMegamenus(except) {
		megamenuTriggers.forEach(function (trigger) {
			if (trigger !== except) setMegamenu(trigger, false);
		});
	}
	function openMegamenuTrigger() {
		return megamenuTriggers.filter(function (trigger) {
			return trigger.getAttribute('aria-expanded') === 'true';
		})[0] || null;
	}

	megamenuTriggers.forEach(function (trigger) {
		trigger.addEventListener('click', function () {
			var open = trigger.getAttribute('aria-expanded') !== 'true';
			closeAllMegamenus(trigger);
			setMegamenu(trigger, open);
		});
	});

	document.addEventListener('click', function (event) {
		var open = openMegamenuTrigger();
		if (!open) return;
		var panel = megamenuPanel(open);
		if (open.contains(event.target)) return;
		if (panel && panel.contains(event.target)) return;
		closeAllMegamenus(null);
	});

	/* ---- Mobile menu drawer + accordions ---- */
	var hamburger = document.querySelector('.m1o2-nav__hamburger');
	var drawer = document.querySelector('.m1o2-nav__drawer');
	var drawerClose = document.querySelector('.m1o2-nav__drawer-close');

	function setDrawer(open) {
		if (!hamburger || !drawer) return;
		hamburger.setAttribute('aria-expanded', String(open));
		drawer.setAttribute('aria-hidden', String(!open));
		drawer.classList.toggle('is-open', open);
		document.body.classList.toggle('nav-open', open);
		if (open && drawerClose) drawerClose.focus();
		if (!open) hamburger.focus();
	}

	if (hamburger && drawer) {
		hamburger.addEventListener('click', function () {
			setDrawer(hamburger.getAttribute('aria-expanded') !== 'true');
		});
		if (drawerClose) {
			drawerClose.addEventListener('click', function () { setDrawer(false); });
		}
	}

	Array.prototype.slice.call(document.querySelectorAll('.m1o2-nav__accordion-header')).forEach(function (header) {
		header.addEventListener('click', function () {
			var accordion = header.closest('.m1o2-nav__accordion');
			var panel = document.getElementById(header.getAttribute('aria-controls'));
			var open = header.getAttribute('aria-expanded') !== 'true';
			header.setAttribute('aria-expanded', String(open));
			if (accordion) accordion.classList.toggle('is-open', open);
			if (panel) panel.setAttribute('aria-hidden', String(!open));
		});
	});

	/* ---- Escape closes any open overlay/dropdown; focus returns to trigger ---- */
	document.addEventListener('keydown', function (event) {
		if (event.key !== 'Escape') return;
		var openTrigger = openMegamenuTrigger();
		if (openTrigger) {
			setMegamenu(openTrigger, false);
			openTrigger.focus();
			return;
		}
		if (hamburger && hamburger.getAttribute('aria-expanded') === 'true') setDrawer(false);
	});

	/* ---- Cart utility: open Dawn's cart drawer when present (href /cart fallback) ---- */
	Array.prototype.slice.call(document.querySelectorAll('.m1o2-nav__util--cart')).forEach(function (link) {
		link.addEventListener('click', function (event) {
			var cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer && typeof cartDrawer.open === 'function') {
				event.preventDefault();
				cartDrawer.open(link);
			}
		});
	});

	/* ---- Video feature: design play disc starts the video (m1o2-video-feature) ----
	   The <video> ships with native controls so it works without this script. Here they
	   are hidden while the disc shows; pressing the disc plays, restores the controls and
	   moves focus onto the video so keyboard users keep control of it. */
	Array.prototype.slice.call(document.querySelectorAll('.m1o2-video-feature__media')).forEach(function (media) {
		var video = media.querySelector('.m1o2-video-feature__video');
		var play = media.querySelector('.m1o2-video-feature__play-btn');
		if (!video || !play) return;
		video.controls = false;
		play.hidden = false;
		play.addEventListener('click', function () {
			play.hidden = true;
			video.controls = true;
			var started = video.play();
			if (started && typeof started.catch === 'function') {
				started.catch(function () { /* playback blocked: native controls are back */ });
			}
			video.focus();
		});
	});

	/* ---- Nav cart count, kept live ----
	   The badge is server-rendered from cart.item_count, so an AJAX add (home / landing /
	   PDP cards, cart drawer, Dawn's own forms) left it stale until a reload. Every caller
	   uses fetch against the Cart API, so any successful /cart/add|change|update|clear
	   response triggers one /cart.js read and the badge is redrawn from it. The wrapper only
	   observes: the original request and response pass through untouched. */
	var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

	function setCartCount(count) {
		Array.prototype.forEach.call(document.querySelectorAll('.m1o2-nav__util-icon--cart'), function (icon) {
			var badge = icon.querySelector('.m1o2-nav__cart-count');
			if (!(count > 0)) {
				if (badge) badge.remove();
				return;
			}
			if (!badge) {
				badge = document.createElement('span');
				badge.className = 'm1o2-nav__cart-count';
				badge.setAttribute('aria-hidden', 'true');
				icon.appendChild(badge);
			}
			badge.textContent = String(count);
		});
	}

	function refreshCartCount() {
		var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
		nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
			.then(function (response) { return response.ok ? response.json() : null; })
			.then(function (cart) {
				if (!cart || typeof cart.item_count !== 'number') return;
				setCartCount(cart.item_count);
				/* One signal for every cart change, whichever script made it (the m1o2 card scripts
				   don't all publish Dawn's cartUpdate); assets/m1o2-cart-drawer.js re-renders on it. */
				document.dispatchEvent(new CustomEvent('m1o2:cart:changed', { detail: { cart: cart } }));
			})
			.catch(function () { /* badge stays as rendered; the next page load corrects it */ });
	}

	var nativeFetch = window.fetch && window.fetch.bind(window);
	if (nativeFetch && !window.__m1o2CartCountWrapped) {
		window.__m1o2CartCountWrapped = true;
		window.fetch = function (input) {
			var url = typeof input === 'string' ? input : (input && input.url) || '';
			var result = nativeFetch.apply(window, arguments);
			var path = url;
			try { path = new URL(url, window.location.href).pathname; } catch (error) { /* keep raw url */ }
			if (CART_MUTATION.test(path)) {
				result.then(function (response) { if (response && response.ok) refreshCartCount(); }, function () {});
			}
			return result;
		};
	}
})();
